import SvgBlogInstagram from 'src/assets/svg/SvgBlogInstagram.svg';
import SvgBlogFacebook from 'src/assets/svg/SvgBlogFacebook.svg';
import SvgBlogLinkedin from 'src/assets/svg/SvgBlogLinkedin.svg';
import SvgBlogYoutube from 'src/assets/svg/SvgBlogYoutube.svg';
import SvgBlogTwitter from 'src/assets/svg/SvgBlogTwitter.svg';
import SvgBlogTiktok from 'src/assets/svg/SvgBlogTiktok.svg';
import SvgBlogThread from 'src/assets/svg/SvgBlogThread.svg';
import SvgBlogEmail from 'src/assets/svg/SvgBlogEmail.svg';

export const SOCIAL_MEDIA = [
    { url: 'facebookLink', img: SvgBlogFacebook },
    { url: 'linkedinLink', img: SvgBlogLinkedin },
    { url: 'tiktokLink', img: SvgBlogTiktok },
    { url: 'youtubeLink', img: SvgBlogYoutube },
    { url: 'twitterLink', img: SvgBlogTwitter },
    { url: 'instagramLink', img: SvgBlogInstagram },
    { url: 'threadLink', img: SvgBlogThread },
    { url: 'publicEmail', img: SvgBlogEmail },
];
